import { dispatcher, api } from '@unicus/react-ui-kit';

export const PARTNERSHIP = 'PARTNERSHIP';

export const PARTNERSHIP_INVITATION_RESEND = 'PARTNERSHIP_INVITATION_RESEND';
export const PARTNERSHIP_INVITATION_RESEND_FINISHED =
  'PARTNERSHIP_INVITATION_RESEND_FINISHED';

export const PARTNERSHIP_LICENSE_SUMMARY = 'PARTNERSHIP_LICENSE_SUMMARY';
export const PARTNERSHIP_LICENSE_SUMMARY_FINISHED =
  'PARTNERSHIP_LICENSE_SUMMARY_FINISHED';

export const resendEmail = (id, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'partnerships',
    actionType: PARTNERSHIP_INVITATION_RESEND,
    effect: async () => api.put(`partnerships/${id}/resend-email`),
    onSuccess
  });
};

export const getSummary = (onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'partnerships',
    actionType: PARTNERSHIP_LICENSE_SUMMARY,
    effect: async () => api.get('partnerships', 'summary'),
    onSuccess
  });
};
